export default __webpack_public_path__ + "static/media/CloseIcon.747172b0.svg";